import React, {useState, useEffect} from 'react';
import Sidebar from '../Sidebar';
import { useFirestore } from 'reactfire';
import { Button, Modal, Skeleton, Form, Input, Radio, Table, message, Popconfirm } from 'antd';
import {DeleteOutlined, CloseCircleOutlined, FileTextOutlined} from '@ant-design/icons';
import { AutoComplete } from 'antd';

const ManageMedicine = () => {

    const layout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 },
    };

    const firestore = useFirestore();
    const query = firestore.collection("Treatment");
    const [state, setState] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addNewModal, setAddNewModal] = useState(false);
    const [form] = Form.useForm();
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [showReset, setShowReset] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [editID, setEditID] = useState();

    useEffect(() => {
        getAllRecords();
    }, []);


    const getAllRecords = () => {
        let records = [];
        setLoading(true);
        query.get().then((querySnapshot) => {
            let index = 0;
            querySnapshot.forEach((doc) => {
                ++ index;
                records.push({record: doc.data(), key: doc.id, numbers: index});
            });
        }).finally(() => {
            setState(records);
            setLoading(false);
        })
    }

    const onChange = (data) => {
        setValue(data);
    };

    const editCurrentMedicine = (rec) => {
        setEditID(rec.key);
        query.doc(rec.key).get().then((response) => {
            form.setFieldsValue({
                medicine_name: response.data().medicine_name,
                formula: response.data().formula,
                type: response.data().type,
                weight: response.data().weight,
                note: response.data().note
            });
            setAddNewModal(true);
        });
        
    }

    const columns = [
        {
            title: 'Numbers',
            dataIndex: 'numbers',
            key: 'key', 
        },
        {
            title: 'Brand Name',
            dataIndex: 'record',
            key: 'key',
            render: (res) => res && res.medicine_name,
        },
        {
            title: 'Generic Name',
            dataIndex: 'record',
            key: 'key',
            render: (res) => res && res.formula,
        },
        {
            title: 'Dose',
            dataIndex: 'record',
            key: 'key',
            render: (res) => res && res.weight,
        },
        {
            title: 'Type',
            dataIndex: 'record',
            key: 'key',
            render: (res) => res && res.type,
        },
        { 
            title: 'Note',
            dataIndex: 'record',
            key: 'key',
            render: (res) => res && res.note,
        },
        {
            title: 'Actions',
            key: Math.random(),
            render: (_, record) => <>
            <FileTextOutlined onClick={() => editCurrentMedicine(record)} style={{ color: '#1890ff', fontSize: '18px', marginRight: '10px'}} />
            
            <Popconfirm title="Sure to delete?" onConfirm={() => deleteCurrent(record)}>

            <DeleteOutlined  style={{ color: '#f00', fontSize: '18px'}} />
          </Popconfirm></>
          }
      ];

      const cancelAddModal = () => {
        setAddNewModal(false);
      }

      const deleteCurrent = (id)=> {
        query.doc(id.key).delete().then(() => {
            getAllRecords();
            message.success('Record Deleted successfully');
        })

      }

    const onSelect = (data) => {
        // console.log(data);
        setShowReset(true);
        setLoading(true);
        // setState([{name: {name: data}, key: Math.random(), numbers: 1}]);
        let records = [];
        query.where("medicine_name", "==", data).get().then((querySnapshot) => {
            let index = 0;
            querySnapshot.forEach((doc) => {
                ++ index;
                records.push({record: doc.data(), key: doc.id, numbers: index});
            });
        }).finally(() => {
            setState(records);
            setLoading(false);
        });
    };


    const onSearch = (searchText) => {
        let records = [];
        query.orderBy('medicine_name')
        .startAt(searchText)
        .endAt(searchText+"\uf8ff").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              records.push({value: doc.data().medicine_name});
          });
          setOptions(records);
        });
      };

    const onNewRecord = (values) => {
        setLoadingBtn(true);
        if (editID) {
            query.doc(editID).update({
                medicine_name: values.medicine_name,
                formula: values.formula,
                weight: values.weight,
                type: values.type,
                note: values.note ? values.note : '',
            }).then(() => {
                setAddNewModal(false);
                getAllRecords();
                form.resetFields();
                setLoadingBtn(false);
            });
        } else {
            query.add({
                medicine_name: values.medicine_name,
                formula: values.formula,
                weight: values.weight,
                type: values.type,
                note: values.note ? values.note : '',
            }).then(() => {
                setAddNewModal(false);
                getAllRecords();
                form.resetFields();
                setLoadingBtn(false);
            });
        }
        

    }

    const onFinishFailed = (values) => {
        console.log(values);
    }

    const addNewMedicin = () => {
        form.setFieldsValue({
            medicine_name: '',
            formula: '',
            type: '',
            weight: '',
            note: ''
        });
        setAddNewModal(true); 
        setEditID(null);
    }


    return (
        <React.Fragment>
            <Sidebar showAppointments={false}/>
            <div className='container'>
            {/* <Table columns={appColumns} dataSource={appointments} pagination={{ pageSize: 30 }}/> */}

            {loading ? <Skeleton active /> : <>

            <div className='newRecAddTopPanel'>
            <Button type="primary" onClick={addNewMedicin} style={{position: 'absolute', top: '30px', right: '30px'}}>
                Add New Record
                </Button>

                <AutoComplete
                    value={value}
                    options={options}
                    style={{
                    width: 500,
                    display: 'block',
                    }}
                    onSelect={onSelect}
                    onSearch={onSearch}
                    onChange={onChange}
                    placeholder="Search"
                />
                {showReset && <div className='reset_rcrd'>
                    <CloseCircleOutlined onClick={() => {setShowReset(false); setValue(''); getAllRecords()} } />
                </div>}

            </div>
                
            <Table columns={columns} dataSource={state} />
            
            </>}
            </div>

            <Modal
          title="Add new Record"
          visible={addNewModal}
          onCancel={cancelAddModal}
          footer={null}
        >
          <Form
            {...layout}
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            onFinish={onNewRecord}
            onFinishFailed={onFinishFailed}
            >
               

            <Form.Item
                label="Brand Name"
                name="medicine_name"
                rules={[{ required: true, message: 'Please add Brand Name' }]}
            >
                <Input size="large" />
            </Form.Item>

            <Form.Item
                label="Generic Name"
                name="formula"
                rules={[{ required: true, message: 'Please add Generic Name' }]}
            >
                <Input size="large" />
            </Form.Item>

            <Form.Item
                label="Type"
                name="type"
                rules={[{ required: true, message: 'Please add Medicine Type' }]}
            >
                {/* <Input size="large" /> */}
                <Radio.Group buttonStyle="solid" size="large">
                    <Radio.Button value={'Tablet'}>Tablet</Radio.Button>
                    <Radio.Button value={'capsule'}>Capsule</Radio.Button>
                    <Radio.Button value={'Syrup'}>Syrup</Radio.Button>
                    <Radio.Button value={'Drops'}>Drops</Radio.Button>
                    <Radio.Button value={'Injection'}>Injection</Radio.Button>
                    <Radio.Button value={'Cream / Ointment'}>Cream / Ointment</Radio.Button>
                    <Radio.Button value={'Spray'}>Spray</Radio.Button>
                    <Radio.Button value={'Other'}>Other</Radio.Button>

                </Radio.Group>
            </Form.Item>

            <Form.Item
                label="Dose"
                name="weight"
                rules={[{ required: true, message: 'Please add Medicine Dose' }]}
            >
                <Input size="large" />
            </Form.Item>

            <Form.Item
                label="Note"
                name="note"
            >
                <Input size="large" />
            </Form.Item>

            <Form.Item>
                <Button type="primary" loading={loadingBtn} htmlType="submit">
                Submit
                </Button>
            </Form.Item>
            
          </Form>
        </Modal>

        </React.Fragment>
    );
}

export default ManageMedicine;
